module.exports = __webpack_public_path__ + "static/img/promotion2_1.d250528a.png";